export default "__VITE_ASSET__Ccfko1DG__"